(function () {
    'use strict';

    /**
     * Exhibitors section (Exhibitors / Sponsors / ParticipatingCompanies) - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_Exhibitors.cshtml),
     * the attribute value is the section type to load.
     * No template and a child scope, so the Razor markup inside binds to "exhibitorsSection"
     * and still sees the page "vm" (getStyle, showLoading, showExhibitorModal).
     * When offline the last data saved in the local storage is shown.
     */
    angular
        .module('EventListApp')
        .directive('wsSectionExhibitors', sectionExhibitors);

    function sectionExhibitors() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionExhibitorsCtrl,
            controllerAs: 'exhibitorsSection'
        };
    }

    SectionExhibitorsCtrl.$inject = ['$element', '$attrs', 'ApiFactory', 'Constants', 'SectionRegistry', '$localstorage'];

    function SectionExhibitorsCtrl($element, $attrs, ApiFactory, Constants, SectionRegistry, $localstorage) {
        const vm = this;
        const EventListSections = Constants.EventListSections;
        vm.lists = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the exhibitors of the section type
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise<boolean>|boolean} true when data was received
         */
        function load(eventId, lang) {
            const source = getSource($attrs.wsSectionExhibitors);
            const storageKey = source.storageKey + eventId;

            if (!navigator.onLine) {
                const data = $localstorage.GetNoExpiry(storageKey);
                if (isEmpty(data) == false)
                    vm.lists = data;

                return true;
            }

            return source.api(eventId, lang).then(function (response) {
                if (response.data == null)
                    return false;

                $localstorage.Save(storageKey, response.data);
                if (source.hasItems(response.data))
                    vm.lists = response.data;

                return true;
            });
        }

        /**
         * api, local storage key and "has items" rule of a section type
         * @param {string} type
         */
        function getSource(type) {
            switch (type) {
                case EventListSections.Sponsors:
                    return { api: ApiFactory.GetSponsors, storageKey: 'sponsors_', hasItems: hasProperties };
                case EventListSections.ParticipatingCompanies:
                    return { api: ApiFactory.GetParticipatingCompanies, storageKey: 'expc_', hasItems: hasProperties };
                default:
                    return { api: ApiFactory.GetExhibitors, storageKey: 'exhibitors_', hasItems: hasLength };
            }
        }

        function hasLength(data) {
            return data.length > 0;
        }

        function hasProperties(data) {
            return isEmpty(data) == false;
        }

        function isEmpty(obj) {
            for (let key in obj) {
                if (obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        }
    }
})();
